import Colors from "../assets/constants/Colors";
import { Spacers } from "../assets/constants/Spacers";
import FeatureItemsStrip from "../components/FeatureItemStrip";
import styled from "../styled-components";

const { pageContent } = Spacers;

const Process = () => {

  return (
    <PageContainer>
      <PageContentContainer>
        
        <SectionTitleText id={"ProcessTitleId"}>
          <BodyText>{"Process"}</BodyText>
        </SectionTitleText>
        <PageSectionContainer>
          <SectionSubTitleText>{"Overview"}</SectionSubTitleText>
          <FeatureItemsStrip/>
        </PageSectionContainer>

        <SectionSubTitleText>{"Details"}</SectionSubTitleText>
        <PageSectionContainer>    
          <OverlineRow>
            <Overline>{"Ask & Prepare"}</Overline>
            <RuleFirst aria-hidden="true" />
          </OverlineRow>
          <BodyText>{"Every data-driven project begins with a business task, a clear question or problem the analysis will answer. Analysts define the task, identify the data needed, and plan ethical, fair collection. Fairness means avoiding bias, considering all available data, and including diverse perspectives or self-reported inputs. This step creates a trustworthy foundation for people-centered insights."}</BodyText>
        </PageSectionContainer>

        <PageSectionContainer>
          <OverlineRow>
            <Overline>{"Process & Analyze"}</Overline>
            <RuleSecond aria-hidden="true" />
          </OverlineRow>
          <BodyText>{"After scoping the question, analysts clean, organize, and explore the data to uncover patterns and relationships. Spreadsheets suit small datasets, while SQL handles larger, more complex ones. Analysts examine context and surrounding factors that might influence results. The goal is to turn raw data into accurate, meaningful findings that reflect the full picture."}</BodyText>
        </PageSectionContainer>

        <PageSectionContainer>
          <OverlineRow>
            <Overline>{"Visualize & Share"}</Overline>
            <RuleThird aria-hidden="true" />
          </OverlineRow>
          <BodyText>{"Next, insights are translated into clear visuals that stakeholders can grasp quickly. Charts, dashboards, and concise reports reveal trends, comparisons, and key takeaways at a glance. Transparent storytelling is essential so visuals highlight the truth rather than distort it. This stage helps audiences connect with the data and understand what it implies."}</BodyText>
        </PageSectionContainer>

        <PageSectionContainer>
          <OverlineRow>
            <Overline>{"Act"}</Overline>
            <RuleFourth aria-hidden="true" />
          </OverlineRow>
          <BodyText>{"Insights fuel action that guides confident, ethical, data-driven decisions. Organizations use results to optimize operations, improve products and services, and design fairer systems. Analysts assess the impact of decisions and feed lessons back into future work. Data becomes a tool for efficiency, fairness, and continuous improvement."}</BodyText>
        </PageSectionContainer>

        <PageSectionContainer>
        </PageSectionContainer>

      </PageContentContainer>
    </PageContainer>
  );
};
export default Process;

export const cardStyles = {
  alignItems: "center",
  backgroundColor: Colors.surfaceForeground,
  borderColor: Colors.surfaceForegroundBorder,
  marginBottom: "15px",
};

const PageContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const PageContentContainer = styled.div`
  width: 100%;
  max-width: ${pageContent.maxWidth.px};
  margin: 0 auto;
  padding: ${pageContent.padding.top.px} ${pageContent.padding.horizontal.px} ${pageContent.padding.bottom.px};
  overflow: auto;
`;

const PageSectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  margin-bottom: 25px;
`;

const SectionTitleText = styled.h2``;
const SectionSubTitleText = styled.h3``;
const BodyText = styled.p``;

const OverlineRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  margin-bottom: 12px;
`;

const Overline = styled.span`
  color: #8a8a8a;
  font-size: 14px;
  letter-spacing: 0.4px;
`;

const RuleFirst = styled.span`
  height: 2px;
  width: 92px;
  background: #e5e5e5;
  border-radius: 2px;
`;

const RuleSecond = styled.span`
  height: 2px;
  width: 118px;
  background: #e5e5e5;
  border-radius: 2px;
`;

const RuleThird = styled.span`
  height: 2px;
  width: 114px;
  background: #e5e5e5;
  border-radius: 2px;
`;

const RuleFourth = styled.span`
  height: 2px;
  width: 17px;
  background: #e5e5e5;
  border-radius: 2px;
`;
